document.querySelector('variant-selection')?.addEventListener('variant-change', function(event) {
  const newVariantId = parseInt(event.detail.variant.id);
  document.querySelectorAll('[data-toggles-with-variant]').forEach((el) => {
    el.classList.toggle('hidden', parseInt(el.dataset.variantId) !== newVariantId);
  });
  document.querySelectorAll('[data-toggle-visibility]').forEach((el) => {
    const visibleVariantIds = JSON.parse(el.dataset.variantIds).map(el => parseInt(el));
    el.classList.toggle('hidden', !visibleVariantIds.includes(newVariantId));
  });
});
      
if (!customElements.get('custom-tab')) {
  customElements.define('custom-tab', class CustomTab extends HTMLElement {
    constructor() {
      super();
/*
      if(this.dataset.toggleVisibility !== undefined) {
        this.visibleVariantIds = JSON.parse(this.dataset.variantIds).map(el => parseInt(el));
        document.querySelector('variant-selection').addEventListener('variant-change', this.onVariantChange.bind(this));
      }
*/
    }
/*
    onVariantChange(event) {
      const newVariantId = parseInt(event.detail.variant.id);
      if(!newVariantId) return;
      
      this.toggleTabVisibility(newVariantId);
    }

    toggleTabVisibility(newVariantId) {
      this.classList.toggle('hidden', !this.visibleVariantIds.includes(newVariantId));
    }
*/
  });
}
